export { Button } from './Button';
export { Badge } from './Badge';
export { SectionHeader } from './SectionHeader';
export { Card } from './Card';
export { EmptyState } from './EmptyState';
export { Ribbon } from './Ribbon';

// One content width for every home section, so section edges line up with the
// wide navbar and footer. A px value on purpose: `html` is 14px here, which
// shrinks the rem-based max-w-* scale (max-w-6xl resolves to 1008px).
export const PAGE_CONTAINER = 'max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8';
